export default function CreateGetReviewDataAction(licenceApplicationId) {
    return (dispatch, getState) => {
        // Set loading state
        dispatch({
            type: "REVIEW_DATA_LOADING",
            data: true
        });

        // Clear any previous errors
        dispatch({
            type: "REVIEW_DATA_ERROR",
            data: null
        });

        return fetch(`/api/LicenceApplication/GetReviewByLicenceApplicationId?licenceApplicationId=${licenceApplicationId}`)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                dispatch({
                    type: "REVIEW_DATA_LOADING",
                    data: false
                });

                if (data.success && data.reviewData) {
                    dispatch({
                        type: "REVIEW_DATA_RETRIEVED",
                        data: data.reviewData
                    });
                } else {
                    dispatch({
                        type: "REVIEW_DATA_RETRIEVED",
                        data: null
                    });
                }
            })
            .catch(error => {
                console.error('Error fetching review data:', error);
                
                dispatch({
                    type: "REVIEW_DATA_LOADING",
                    data: false
                });
                
                dispatch({
                    type: "REVIEW_DATA_ERROR",
                    data: error.message || 'Failed to fetch review data'
                });
            });
    };
} 